import { FC, useRef, ChangeEvent, ReactNode, useState } from 'react'
import { Container, InputLabel, InputBox } from './styles'
import { IoClose } from 'react-icons/io5'
import { IoIosCheckmarkCircle } from 'react-icons/io'
import FileData from '../../../dtos/fileData'
import loadingImg from 'src/assets/loader-green.svg'
import { useErrors } from 'src/context/errors'

type FilePickerProps = {
  title?: ReactNode;
  accept?: string;
  limit?: number;
  onFilesSelect: (files: File[]) => Promise<void>;
  selectedFiles: FileData[];
  isIncorrect?: boolean;
  errorMessage?: string;
  fontSize?: string;
  errorCode?: string;
}

const FilePicker: FC<FilePickerProps> = ({ title, accept, limit, onFilesSelect, selectedFiles, isIncorrect, errorMessage, fontSize, errorCode = '' }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isLoading, setIsLoading] = useState(false)

  const { hasError, getErrorMessage } = useErrors()

  isIncorrect = hasError(errorCode) || isIncorrect
  errorMessage = getErrorMessage(errorCode) || errorMessage

  const handleInputClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.click()
    }
  }

  const handleFileSelect = async (event: ChangeEvent<HTMLInputElement>) => {
    const { files } = event.target
    if (files && files?.length > 0) {
      setIsLoading(true)
      const filesArray = Array.from(files)
      await onFilesSelect(filesArray)
      setIsLoading(false)
    }
  }

  const handleRemoveFiles = () => onFilesSelect([])

  const hasFiles = selectedFiles &&
    selectedFiles.length > 0 &&
    !!selectedFiles[0].id

  return (
    <Container>
      {fontSize === 'small' ?
        <div style={{ fontSize: '16px', color: '#353744', fontWeight: 900 }}>
          {title}
        </div>
        :
        <InputLabel className="file-picker-label">{title}</InputLabel>
      }
      <InputBox data-error-code={errorCode} isIncorrect={isIncorrect} hasFiles={hasFiles} className="file-picker-input">
        <button onClick={handleInputClick} disabled={isLoading}>Choose File</button>
        <div>
          {hasFiles ? <IoIosCheckmarkCircle /> : null}
          {isLoading ? <img src={loadingImg} alt="loading" /> : null}
          <span>{hasFiles ? selectedFiles.map(f => f.fileName).join(', ') : 'No file chosen'}</span>
        </div>
        <input ref={inputRef} type="file" accept={accept} multiple={(!!limit && limit > 1)} onChange={handleFileSelect} />
        {hasFiles ? (
          <button className='file-picker-close-button' onClick={handleRemoveFiles}>
            <IoClose />
          </button>
        ) : null}
      </InputBox>
      {errorMessage ? (
        <small>{errorMessage}</small>
      ) : null}
    </Container>
  )
}

export default FilePicker